export default __webpack_public_path__ + "static/media/7879.97862ec0.svg";